import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Generate from "./pages/Generate";
import Results from "./pages/Results";
import Pricing from "./pages/Pricing";
import Showcase from "./pages/Showcase";
import Billing from "./pages/Billing";
import Invoice from "./pages/Invoice";
import PaymentSuccess from "./pages/PaymentSuccess";
import ShippingPolicy from "./pages/ShippingPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import "@/App.css";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="p-12 text-center font-mono">Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function Shell({ children }) {
    return (
        <div className="App min-h-screen bg-paper flex flex-col">
            <Navbar />
            <div className="flex-1">{children}</div>
            <Footer />
        </div>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors />
                <Routes>
                    <Route path="/" element={<Shell><Landing /></Shell>} />
                    <Route path="/login" element={<Shell><Login /></Shell>} />
                    <Route path="/register" element={<Shell><Register /></Shell>} />
                    <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
                    <Route path="/reset-password/:token" element={<Shell><ResetPassword /></Shell>} />
                    <Route path="/pricing" element={<Shell><Pricing /></Shell>} />
                    <Route path="/showcase" element={<Shell><Showcase /></Shell>} />
                    <Route path="/shipping-policy" element={<Shell><ShippingPolicy /></Shell>} />
                    <Route path="/refund-policy" element={<Shell><RefundPolicy /></Shell>} />
                    <Route path="/terms" element={<Shell><Terms /></Shell>} />
                    <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
                    <Route path="/dashboard" element={<Shell><Protected><Dashboard /></Protected></Shell>} />
                    <Route path="/generate" element={<Shell><Protected><Generate /></Protected></Shell>} />
                    <Route path="/results/:id" element={<Shell><Protected><Results /></Protected></Shell>} />
                    <Route path="/billing" element={<Shell><Protected><Billing /></Protected></Shell>} />
                    <Route path="/billing/invoice/:orderId" element={<Protected><Invoice /></Protected>} />
                    <Route path="/payment/success" element={<Shell><Protected><PaymentSuccess /></Protected></Shell>} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
